export default __webpack_public_path__ + "static/media/background-pattern.4e517b76.png";